import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  const friendLinks = [
    { label: "免费视频资源导航", to: "/" },
    { label: "高清视频分类大全", to: "/category/documentary" },
    { label: "热门视频排行榜", to: "/category/entertainment" },
    { label: "在线观看入口", to: "/search" },
  ];

  return (
    <footer className="mt-16 bg-primary-950 text-primary-100">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-play-fill text-2xl leading-none" />
              </span>
              <span className="font-heading text-lg font-extrabold text-background-50">
                黄色免费视频
              </span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200/90">
              专注于免费视频资源在线聚合与展示，提供多分类浏览、快速筛选与便捷观看体验，让每一次打开都值得。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <Link to="/category/comedy">视频分类</Link>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-sm text-primary-200 hover:text-accent-300 transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <Link to="/about">关于与帮助</Link>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-primary-200 hover:text-accent-300 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-primary-200 hover:text-accent-300 transition-colors">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-primary-200 hover:text-accent-300 transition-colors">
                  搜索结果
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-primary-200 hover:text-accent-300 transition-colors">
                  隐私政策
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <Link to="/">友情链接</Link>
            </h4>
            <ul className="space-y-2.5">
              {friendLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-primary-200 hover:text-accent-300 transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-primary-300">
            本站内容均为网络公开资源的聚合展示，仅供学习与交流使用。
          </p>
          <p className="text-xs text-primary-300">
            © {year} 黄色免费视频 · 保留所有权利
          </p>
        </div>
      </div>
    </footer>
  );
}